import englishLogo from '../../Images/english.jpg'
import swedishLogo from '../../Images/swedish.jpg'
import finnishLogo from '../../Images/finnish.jpg'
import latviaLogo from '../../Images/latvian.jpg'
import estonianLogo from '../../Images/estonian.jpg'
import norwegianLogo from '../../Images/norwegian.jpg'
import germanLogo from '../../Images/german.jpg'
import swedishFinnishLogo from '../../Images/swedish_finland.jpg'
import { useTranslation } from 'react-i18next'
import { Language } from '../../Models/Enums'
import './FlagContainer.scss'


const FlagContainer = () => {
	const { i18n } = useTranslation();
	return (
		<>
			<img className='image' src={englishLogo} width="50" alt='English' title='English' onClick={() => i18n.changeLanguage(Language.English)} />
			<img className='image' src={swedishLogo} width="50" alt='Swedish' title='Swedish' onClick={() => i18n.changeLanguage(Language.Swedish)} />
			<img className='image' src={finnishLogo} width="50" alt='Finnish' title='Finnish' onClick={() => i18n.changeLanguage(Language.Finnish)} />
			<img className='image' src={latviaLogo} width="50" alt='Latvia' title='Latvia' onClick={() => i18n.changeLanguage(Language.Latvia)} />
			<img className='image' src={swedishFinnishLogo} width="50" alt='SwedishFinnish' title='SwedishFinnish' onClick={() => i18n.changeLanguage(Language.Swedish)} />
			<img className='image' src={estonianLogo} width="50" alt='Estonian' title='Estonian' onClick={() => i18n.changeLanguage(Language.Estonia)} />
			<img className='image' src={norwegianLogo} width="50" alt='Norwegian' title='Norwegian' onClick={() => i18n.changeLanguage(Language.Norway)} />
			<img className='image' src={germanLogo} width="50" alt='German' title='German' onClick={() => i18n.changeLanguage(Language.German)} />
		</>
	)
}

export default FlagContainer